module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/trophy-brigade-lvl3-100.5917b144.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/trophy-brigade-lvl3-100.png
// module id = 3585
// module chunks = 11